function joinPath(base, routePath) {
  if (routePath == null || routePath === '') return base || '/'
  const raw = String(routePath)
  if (raw.startsWith('http')) return raw
  if (raw.startsWith('/')) return raw
  const b = String(base || '').replace(/\/$/, '')
  return b ? `${b}/${raw}` : `/${raw}`
}

function visibleChildren(route) {
  return (route.children || []).filter((child) => !child.hidden)
}

function isAlwaysShow(route) {
  return !!(route.meta && route.meta.alwaysShow)
}

function titleOf(route) {
  return (route.meta && route.meta.title) || ''
}

function isExternal(routePath) {
  return String(routePath || '').startsWith('http')
}

/**
 * 移动端各模块下只展示这些功能，顺序固定。
 * 路由名对应页面：会员注册即「注册会员」。
 * 无权限而被 hidden 的项不出现；forceHideInSidebar 只影响电脑侧栏，移动端仍可列出。
 */
const MOBILE_MODULE_PAGES = {
  member: ['memberList', 'memberRegister'],
  integration: [
    'exchangeIntegrationHistory',
    'innerIntegrationStatsReport',
    'adminGiftVerifyCard',
    'innerIntegrationGiftBatch',
    'innerGiftActivation',
    'integrationMemberInner'
  ],
  verify: ['verifyCardList', 'verifyManage'],
  pms: ['innerRedeemProductList'],
  oms: ['order', 'shipmentRecord']
}

function collectAllowedPages(route, base, allowedNames) {
  const byName = {}
  ;(route.children || []).forEach((child) => {
    if (!child.name || allowedNames.indexOf(child.name) < 0) return
    const sidebarOnlyHidden = child.meta && child.meta.forceHideInSidebar
    if (child.hidden && !sidebarOnlyHidden) return
    const path = joinPath(base, child.path)
    const title = titleOf(child)
    if (!title || !path) return
    byName[child.name] = {
      title,
      path,
      external: isExternal(child.path)
    }
  })
  return allowedNames.map((name) => byName[name]).filter(Boolean)
}

/** 移动端顶部模块顺序。无权限（侧栏已隐藏）的项不会出现。 */
const MOBILE_MODULE_ORDER = ['home', 'member', 'integration', 'verify', 'pms', 'oms']

/**
 * 把侧栏路由收成移动端顶部两行：模块 + 当前模块下的页面。
 * 单子项收束规则与 SidebarItem.canCollapseToSingleItem 一致。
 */
export function buildMobileModules(routes) {
  const modules = []
  ;(routes || []).forEach((route) => {
    if (route.hidden || !route.children) return
    const base = route.path || ''
    const id = route.name || ''
    const allowedNames = MOBILE_MODULE_PAGES[id]
    if (allowedNames) {
      const pages = collectAllowedPages(route, base, allowedNames)
      if (!pages.length) return
      modules.push({
        key: id,
        title: titleOf(route) || pages[0].title,
        path: pages[0].path,
        external: false,
        matchPrefix: base && base !== '/' ? base : '',
        pages
      })
      return
    }
    const visible = visibleChildren(route)
    const collapse = !isAlwaysShow(route) && visible.length === 1 && !visible[0].children
    if (collapse) {
      const only = visible[0]
      const path = joinPath(base, only.path)
      const title = titleOf(only)
      const collapsedId = only.name || route.name || ''
      if (!title || !path || MOBILE_MODULE_ORDER.indexOf(collapsedId) < 0) return
      modules.push({
        key: collapsedId,
        title,
        path,
        external: isExternal(only.path),
        matchPrefix: base && base !== '/' ? base : path,
        pages: []
      })
      return
    }
  })
  modules.sort((a, b) => MOBILE_MODULE_ORDER.indexOf(a.key) - MOBILE_MODULE_ORDER.indexOf(b.key))
  return modules
}

export function pathUnder(base, current) {
  if (!base || !current) return false
  if (current === base) return true
  const prefix = base.endsWith('/') ? base : `${base}/`
  return current.startsWith(prefix)
}



// WEBPACK FOOTER //
// ./src/views/layout/components/mobileMenu.js